import React from 'react';
import { useTranslation } from 'react-i18next';

const NoGamesFound = ({ title = "Oyunlar", showRefreshButton = false, onRefresh }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      {/* Icon Container */}
      <div className="relative mb-6">
        <div className="w-24 h-24 mx-auto bg-gradient-to-br from-primary-400/50 to-primary-500/70 rounded-full flex items-center justify-center shadow-2xl">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-12 h-12 text-white/70"
          >
            {/* Dış daire */}
            <circle cx="12" cy="12" r="10" strokeWidth={2.5} />
            
            {/* Basit çarpı işareti */}
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 9l-6 6m0-6l6 6"
              strokeWidth={3}
            />
          </svg>
        </div>
        
        {/* Pulse Animation */}
        <div className="absolute inset-0 w-24 h-24 mx-auto bg-secondary-500 rounded-full animate-ping opacity-20"></div>
      </div>

      {/* Title */}
      <h3 className="text-xl font-bold text-white mb-3">
        {t("NO_GAMES_FOUND_TITLE", { title: title })}
      </h3>

      {/* Description */}
      <p className="text-gray-300 text-sm max-w-md leading-relaxed mb-6">
        {t("NO_GAMES_FOUND_DESCRIPTION")}
      </p>

    
      {/* Decorative Elements */}
      <div className="mt-8 flex space-x-2">
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="w-2 h-2 bg-primary-500/30 rounded-full animate-pulse"
            style={{ animationDelay: `${i * 0.2}s` }}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default NoGamesFound;
